import { Roles } from '@nrwl/rx-models';
import { UserActions, UserActionsTypes } from './user.actions';
import { initialUserState, UserState } from './user.state';

export function UserReducer(state = initialUserState, action: UserActions): UserState {
  switch (action.type) {
    // #region load user

    case UserActionsTypes.LoadUser:
      return {
        ...state,
      };

    case UserActionsTypes.LoadUserSuccess: {
      const userData = { ...action.payload };

      if (userData.role === Roles.SuperAdmin || userData.role === Roles.Admin) {
        userData.default_clinic_location = !userData.default_clinic_location
          ? 'null'
          : userData.default_clinic_location;
      }

      return {
        ...state,
        value: userData,
        error: '',
      };
    }

    // #endregion

    // #region load user location

    case UserActionsTypes.LoadLocations:
      return {
        ...state,
      };

    case UserActionsTypes.LoadLocationsSuccess:
      return {
        ...state,
        locations: action.payload,
      };

    // #endregion

    // #region edit user

    case UserActionsTypes.EditUser:
      return {
        ...state,
      };

    // #endregion

    // #region upload user foto

    case UserActionsTypes.UploadUserFoto:
      return {
        ...state,
      };

    // #endregion

    // #region remove user foto

    case UserActionsTypes.ClearUserFoto:
      return {
        ...state,
      };

    // #endregion

    // #region change user password

    case UserActionsTypes.ChageUserPassword:
      return {
        ...state,
      };

    // #endregion

    case UserActionsTypes.LoadUserEventNotifications:
    case UserActionsTypes.LoadUserMessageNotifications:
    case UserActionsTypes.LoadMoreEventNotifications:
    case UserActionsTypes.LoadMoreMessageNotifications:
      return {
        ...state,
        notifications: { ...state.notifications, loading: true },
      };

    case UserActionsTypes.LoadUserEventNotificationsSuccess: {
      const newEvents = <any>[];
      const eventsList = action.payload;

      const eventDates = eventsList.results
        .map((n) => {
          if (!n.is_read) {
            newEvents.push(n.id);
          }
          return n.created_at;
        })
        .filter((value, index, self) => self.indexOf(value) === index);

      const eventNotifications = eventDates.map((date) => {
        const events = eventsList.results.filter((event) => event.created_at === date);
        return { date, events };
      });

      return {
        ...state,
        notifications: {
          ...state.notifications,
          eventNotifications,
          newEvents,
          loading: false,
          eventsNext: eventsList.next,
        },
      };
    }

    case UserActionsTypes.LoadUserMessageNotificationsSuccess: {
      const newMessages = <any>[];
      const messagesList = action.payload;

      const messageDates = messagesList.results
        .map((n) => {
          if (!n.is_read) {
            newMessages.push(n.id);
          }
          return n.created_at;
        })
        .filter((value, index, self) => self.indexOf(value) === index);

      const messageNotifications = messageDates.map((date) => {
        const messages = messagesList.results.filter((message) => message.created_at === date);

        return { date, messages };
      });

      return {
        ...state,
        notifications: {
          ...state.notifications,
          messageNotifications,
          newMessages,
          loading: false,
          messagesNext: messagesList.next,
        },
      };
    }

    case UserActionsTypes.LoadMoreEventNotificationsSuccess: {
      const oldEvents = state.notifications.eventNotifications;
      const newEventsIds = <any>[];
      const dates = action.payload.results
        .map((event) => {
          if (!event.is_read) {
            newEventsIds.push(event.id);
          }
          return event.created_at;
        })
        .filter((value, index, self) => self.indexOf(value) === index);

      const newEvents = dates.map((date) => {
        const events = action.payload.results.filter((event) => event.created_at === date);
        return { date, events };
      });

      if (oldEvents[oldEvents.length - 1].date === newEvents[0].date) {
        const mergedEvent = {
          ...oldEvents[oldEvents.length - 1],
          events: oldEvents[oldEvents.length - 1].events.concat(newEvents[0].events),
        };
        const updatedOldEvents = [...oldEvents.slice(0, -1), mergedEvent];

        const updatedNewEvents = newEvents.slice(1);
      }

      return {
        ...state,
        notifications: {
          ...state.notifications,
          loading: false,
          eventNotifications: [...oldEvents, ...newEvents],
          newEvents: [...state.notifications.newEvents, ...newEventsIds],
          eventsNext: action.payload.next,
        },
      };
    }

    case UserActionsTypes.LoadMoreMessageNotificationsSuccess: {
      const oldMessages = state.notifications.messageNotifications;
      const newMessagesIds = <any>[];
      const dates = action.payload.results
        .map((n: any) => {
          if (!n.is_read) {
            newMessagesIds.push(n.id);
          }
          return n.created_at;
        })
        .filter((value, index, self) => self.indexOf(value) === index);

      const newMessages = dates.map((date) => {
        const messages = action.payload.results.filter((message) => message.created_at === date);
        return { date, messages };
      });

      let updatedOldMessages = [...oldMessages];
      let updatedNewMessages = [...newMessages];

      if (
        updatedOldMessages.length > 0 &&
        updatedNewMessages.length > 0 &&
        updatedOldMessages[updatedOldMessages.length - 1].date === updatedNewMessages[0].date
      ) {
        const lastOld = updatedOldMessages[updatedOldMessages.length - 1];
        const firstNew = updatedNewMessages[0];

        const mergedMessageGroup = {
          ...lastOld,
          messages: [...lastOld.messages, ...firstNew.messages],
        };

        updatedOldMessages = [...updatedOldMessages.slice(0, -1), mergedMessageGroup];
        updatedNewMessages = updatedNewMessages.slice(1);
      }

      return {
        ...state,
        notifications: {
          ...state.notifications,
          loading: false,
          messageNotifications: [...oldMessages, ...newMessages],
          newMessages: [...state.notifications.newMessages, ...newMessagesIds],
          messagesNext: action.payload.next,
        },
      };
    }

    case UserActionsTypes.LoadNotificationCount:
    case UserActionsTypes.ReadEventNotifications:
    case UserActionsTypes.ReadAllNotifications:
    case UserActionsTypes.ReadMessageNotification: {
      return {
        ...state,
      };
    }

    case UserActionsTypes.LoadNotificationCountSuccess: {
      return {
        ...state,
        notifications: { ...state.notifications, notificationAmount: action.payload },
      };
    }

    case UserActionsTypes.ReadAllNotificationsSuccess: {
      const eventNotifications: any = state.notifications.eventNotifications.map((value) => {
        const events = value.events.map((event) => ({
          ...event,
          firstName: event.firstName,
          secondName: event.secondName,
          is_read: true,
        }));
        return { ...value, events };
      });

      const messageNotifications: any = state.notifications.messageNotifications.map((value) => {
        const messages = value.messages.map((message) => ({
          ...message,
          firstName: message.firstName,
          secondName: message.secondName,
          is_read: true,
        }));
        return { ...value, messages };
      });

      return {
        ...state,
        notifications: {
          ...state.notifications,
          notificationAmount: 0,
          eventNotifications,
          messageNotifications,
          newEvents: [],
          newMessages: [],
        },
      };
    }
    case UserActionsTypes.ReadEventNotificationsSuccess: {
      const eventNotifications = state.notifications.eventNotifications.map((value) => {
        const events = value.events.map((event) => {
          return action.payload.some((id) => id === event.id)
            ? { ...event, firstName: event.firstName, secondName: event.secondName, is_read: true }
            : { ...event, firstName: event.firstName, secondName: event.secondName };
        });
        return { ...value, events };
      });

      const newEvents = state.notifications.newEvents.filter(
        (eventId) => !action.payload.some((id) => eventId === id),
      );

      return {
        ...state,
        notifications: {
          ...state.notifications,
          eventNotifications,
          newEvents,
          notificationAmount: state.notifications.notificationAmount - action.payload.length,
        },
      };
    }

    case UserActionsTypes.ReadMessageNotificationSuccess: {
      const messageNotifications = state.notifications.messageNotifications.map((value) => {
        const messages = value.messages.map((message) => {
          message.is_read = true;
          return message;
        });
        return { ...value, messages };
      });

      return {
        ...state,
        notifications: {
          ...state.notifications,
          messageNotifications,
          newMessages: [],
          notificationAmount: state.notifications.notificationAmount - action.payload.length,
        },
      };
    }

    case UserActionsTypes.ResetDefaultSortLocations: {
      return {
        ...state,
        value: { ...state.value, default_clinic_location: null },
      };
    }

    // #region Error

    case UserActionsTypes.Error:
      return {
        ...state,
        error: action.payload,
      };

    // #endregion

    default:
      return state;
  }
}
